import { Box, styled } from '@mui/material';

export const CenteredContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
});
